var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../action/au.action';
import { MessageService } from '../../service/message.service';
import { PageService } from '../../models/page.service';
import { ListService } from './list.service';
import { EntryComponent } from '../entry/entry.component';
import { ColumnService } from '../../items/columns/column/column.service';
import { AlertModalService } from '../alertmodal/alertmodal.service';
import { Btn } from '../../models/button/button';
var BulkComponent = /** @class */ (function (_super) {
    __extends(BulkComponent, _super);
    function BulkComponent(router, route, logger, action, message, page, service, columnService, alertModalService) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.columnService = columnService;
        _this.alertModalService = alertModalService;
        _this.events = { bulk_update: 'bulk_update', bulk_delete: 'bulk_delete' };
        _this.labelError = '';
        _this.labelTitle = '';
        _this.buttons = [];
        _this.recs = [];
        _this.hiddenKeys = [];
        _this.toggle = false;
        _this.error = [];
        return _this;
    }
    BulkComponent.prototype.ngOnInit = function () {
        var _this = this;
        _super.prototype.ngOnInit.call(this);
        var params = this.component.params || {};
        this.groupName = this.service.getGroupName(params.groupName);
        this.service.setBulkPrimaryKey(this.groupName, params.primaryKey);
        if (this.buttons.length > 0) {
            this.service.setBulk(this.groupName, []);
        }
        this.bulkSubsc = this.service.bulkObservable.subscribe(function (data) {
            if (typeof data !== 'undefined' && typeof data[_this.groupName] !== 'undefined') {
                _this.recs = data[_this.groupName];
                var disabled_1 = (_this.recs.length > 0 ? false : true);
                _this.buttons.map(function (btn) { return btn.disabled = disabled_1; });
                _this.labelTitle = _this.message.replaceMessage(_this.msgSnapshot['au.COMPONENT.BulkComponent.label.bulkUpdateTitle'], 'count', _this.recs.length);
                _this.hiddenKeys = [];
                _super.prototype.onSubscribe.call(_this, {});
            }
        });
    };
    BulkComponent.prototype.ngAfterViewInit = function () {
        this.modal = this.remodalElement.nativeElement;
    };
    BulkComponent.prototype.onInit = function (meta) {
        _super.prototype.onInit.call(this, meta);
        if (this.cols.length > 0) {
            for (var _i = 0, _a = this.cols; _i < _a.length; _i++) {
                var col = _a[_i];
                col.required = false;
            }
        }
        this.orgCols = $.extend(true, [], this.cols);
    };
    BulkComponent.prototype.setChangeCompData = function (component) {
        this.setButtons(component);
    };
    BulkComponent.prototype.setButtons = function (component) {
        var params = this.component.params || {};
        var buttons = [];
        var paramsUpdate = params.update;
        if ((typeof paramsUpdate === 'undefined' || paramsUpdate === true) && this.action.validEvent(this.events.bulk_update)) {
            buttons.push(Object.assign(new Btn(), {
                type: 'button',
                event: this.componentName + '#Button#update',
                caption: this.msgSnapshot['au.COMPONENT.BulkComponent.button.bulkUpdate'],
                disabled: true
            }));
        }
        var paramsDelete = params.delete;
        if ((typeof paramsDelete === 'undefined' || paramsDelete === true) && this.action.validEvent(this.events.bulk_delete)) {
            buttons.push(Object.assign(new Btn(), {
                type: 'button',
                event: this.componentName + '#Button#delete',
                caption: this.msgSnapshot['au.COMPONENT.BulkComponent.button.bulkDelete'],
                disabled: true,
                params: { btnClass: { type: 'delete' } }
            }));
        }
        var addButtons = params.buttons || [];
        for (var _i = 0, addButtons_1 = addButtons; _i < addButtons_1.length; _i++) {
            var button = addButtons_1[_i];
            if (this.action.validEvent(button.event)) {
                button.disabled = true;
                buttons.push(button);
            }
        }
        this.buttons = buttons;
        this.error = [];
    };
    BulkComponent.prototype.setUnsubscribe = function () {
        this.modeSubscription.unsubscribe();
        this.changeSubscription.unsubscribe();
    };
    BulkComponent.prototype.onSubscribe = function (data) {
        _super.prototype.onSubscribe.call(this, data);
        this.error = this.setResponseError(data);
        this.toggle = true;
        this.remodal.close();
        this.labelError = this.message.replaceMessage(this.msgSnapshot['au.COMPONENT.BulkComponent.label.errorInfo'], 'count', this.error.length);
        this.alertModalService.open({
            message: this.msgSnapshot['au.COMPONENT.BulkComponent.label.bulkDone'],
            buttons: [{
                    class: 'ok',
                    event: this.componentName + '#done',
                    caption: this.msgSnapshot['Modal.button.ok']
                }]
        });
    };
    BulkComponent.prototype.onEventSubscribe = function (e) {
        if (e === this.componentName + '#Button#update') {
            this.remodal = $(this.modal).remodal({ hashTracking: false, closeOnEscape: false, closeOnOutsideClick: false });
            this.remodal.open();
        }
        else if (e === this.componentName + '#update') {
            this.action.setRec(this.setCompRec());
            this.action.firstAction(this.events.bulk_update);
        }
        else if (e === this.componentName + '#update#cancel') {
        }
        else if (e === this.componentName + '#Button#delete') {
            this.alertModalService.open({
                type: 'warn',
                message: this.message.replaceMessage(this.msgSnapshot['au.COMPONENT.BulkComponent.label.confirmDelete'], 'count', this.recs.length),
                buttons: [{
                        class: 'ok',
                        event: this.componentName + '#delete',
                        caption: this.msgSnapshot['Modal.button.delete']
                    }, {
                        class: 'cancel',
                        event: this.componentName + '#delete#cancel',
                        caption: this.msgSnapshot['Modal.button.cancel']
                    }]
            });
        }
        else if (e === this.componentName + '#delete') {
            this.action.setRec(this.setCompRec());
            this.action.firstAction(this.events.bulk_delete);
        }
        else if (e === this.componentName + '#delete#cancel') {
        }
        else if (e === this.componentName + '#done') {
        }
    };
    BulkComponent.prototype.onEvent = function (e1, e2, rec) {
        if (e2 === 'update') {
            this.alertModalService.open({
                message: this.message.replaceMessage(this.msgSnapshot['au.COMPONENT.BulkComponent.label.confirmUpdate'], 'count', this.recs.length),
                buttons: [{
                        class: 'ok',
                        event: this.componentName + '#update',
                        caption: this.msgSnapshot['Modal.button.update']
                    }, {
                        class: 'cancel',
                        event: this.componentName + '#update#cancel',
                        caption: this.msgSnapshot['Modal.button.cancel']
                    }]
            });
        }
        else if (e2 === 'cancel') {
        }
    };
    BulkComponent.prototype.setRec = function (key, readonly, hidden, params, data) {
        _super.prototype.setRec.call(this, key, readonly, hidden, params, data);
        if (((typeof params === 'undefined') || (typeof params !== 'undefined' && typeof params.initValue === 'undefined')) && hidden) {
            this.hiddenKeys.push(key);
        }
    };
    BulkComponent.prototype.setCompRec = function () {
        var items = [];
        for (var _i = 0, _a = this.recs; _i < _a.length; _i++) {
            var rec = _a[_i];
            var item = {};
            for (var _b = 0, _c = this.hiddenKeys; _b < _c.length; _b++) {
                var key = _c[_b];
                if (typeof rec[key] !== 'undefined' && this.columnService.checkVal(rec[key])) {
                    item[key] = rec[key];
                }
            }
            for (var _d = 0, _e = Object.keys(this.rec); _d < _e.length; _d++) {
                var key = _e[_d];
                if (this.columnService.checkVal(this.rec[key])) {
                    item[key] = this.rec[key];
                }
            }
            items.push(item);
        }
        this.action.setCompRec(this.componentName, { items: items });
        return { items: items };
    };
    BulkComponent.prototype.switchToggle = function () {
        this.toggle = !this.toggle;
    };
    BulkComponent.prototype.setResponseError = function (responses) {
        var error = [];
        for (var _i = 0, responses_1 = responses; _i < responses_1.length; _i++) {
            var r = responses_1[_i];
            if (typeof r.rec === 'undefined' || typeof r.error === 'undefined') {
                continue;
            }
            var disps = [];
            for (var _a = 0, _b = this.cols; _a < _b.length; _a++) {
                var col = _b[_a];
                var disp = false;
                if (col.items) {
                    for (var _c = 0, _d = col.items; _c < _d.length; _c++) {
                        var item = _d[_c];
                        disp = disp || this.checkResponseVal(item.key, r.rec[item.key]);
                    }
                }
                else {
                    disp = this.checkResponseVal(col.key, r.rec[col.key]);
                }
                disps.push(disp);
            }
            error.push({
                rec: r.rec,
                errMsg: r.error ? r.error.message : '',
                errValid: r.error ? this.getValidationError(r.error.validationError) : [],
                disp: disps
            });
        }
        return error;
    };
    BulkComponent.prototype.checkResponseVal = function (key, rec) {
        if (key && this.columnService.checkVal(rec)) {
            return true;
        }
        return false;
    };
    BulkComponent.prototype.getValidationError = function (validationError) {
        var messages = [];
        if (typeof validationError === 'undefined') {
            return messages;
        }
        for (var _i = 0, _a = Object.keys(validationError); _i < _a.length; _i++) {
            var key = _a[_i];
            messages = messages.concat(validationError[key]);
        }
        return messages;
    };
    BulkComponent.prototype.trackByErr = function (index, error) {
        return JSON.stringify(error);
    };
    BulkComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        this.bulkSubsc.unsubscribe();
        if ($(this.modal).parent().hasClass('remodal-wrapper')) {
            this.remodal.destroy();
        }
    };
    BulkComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'bulk',
                    template: "<btn [componentName]=\"componentName\" [component]=\"{params: {buttons: buttons}}\"></btn>\n\n<div id=\"{{ componentName + '#Result' }}\" class=\"filter -mt-1\" *ngIf=\"error.length > 0\">\n  <p class=\"filter_trigger\">\n    <span [class.open]=\"toggle\" (click)=\"switchToggle()\">{{ labelError }}</span>\n  </p>\n  <div class=\"filter_property filter_property_toggle alertBlock\" style=\"height: auto; min-height: 80px;\" [style.display]=\"toggle ? 'block': 'none'\">\n    <ul>\n      <ng-template ngFor let-err [ngForOf]=\"error\" [ngForTrackBy]=\"trackByErr\">\n        <li>\n          <span>{{ err.errMsg }}</span>\n          <ul *ngIf=\"err?.errValid?.length > 0\">\n            <li *ngFor=\"let valid of err.errValid\">\n              <span>{{ valid }}</span>\n            </li>\n          </ul>\n          <p class=\"filter_trigger -ml-1\">\n            <i class=\"filter_triggerStatus\">\n              <ng-template ngFor let-col [ngForOf]=\"cols\" let-index=\"index\" [ngForTrackBy]=\"trackByCol\">\n                <span *ngIf=\"err.disp[index]\" class=\"filter_triggerStatusItem\" [class.-mr-05]=\"index < cols.length - 1\">{{ col.label }}\n                  <span class=\"filter_triggerStatusItemValue\">\n                    <ng-template [ngIf]=\"!col.items\">\n                      <column-formlabel [col]=\"col\" [val]=\"err.rec[col.key]\" [msg]=\"(msg | async)\"></column-formlabel>\n                    </ng-template>\n                    <ng-template ngFor let-item [ngForOf]=\"col.items\" [ngForTrackBy]=\"trackByCol\">\n                      <column-formlabel [col]=\"item\" [val]=\"err.rec[item.key]\" [msg]=\"(msg | async)\"></column-formlabel>\n                    </ng-template>\n                  </span>\n                </span>\n              </ng-template>\n            </i>\n          </p>\n        </li>\n      </ng-template>\n    </ul>\n  </div>\n</div>\n\n<!-- remodal -->\n<div class=\"remodal\" id=\"{{ componentName + '#Remodal#update' }}\" #remodal>\n  <div class=\"remodal_whitebg\">\n    <p>\n      <span class=\"sectionHeading\">{{ labelTitle }}</span>\n    </p>\n    <div class=\"row -mt-3\">\n      <div class=\"col-sm-12\">\n        <form>\n          <ng-template ngFor let-col [ngForOf]=\"cols\" let-index=\"index\" [ngForTrackBy]=\"trackByCol\">\n            <ng-template [ngIf]=\"col.readonly || (!col.readonly && !col.hidden)\" [ngIfElse]=\"elseBlock\">\n              <div class=\"row\" [class.-mb-3]=\"index < cols.length - 1\">\n                <div class=\"col-sm-12\">\n                  <column [key]=\"'form'\" [componentName]=\"componentName\" [col]=\"col\" [val]=\"dispRec\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChange($event)\"></column>\n                </div>\n              </div>\n            </ng-template>\n            <ng-template #elseBlock>\n              <columngroup [componentName]=\"componentName\" [col]=\"col\" [val]=\"dispRec\" (changeVal)=\"onChange($event)\"></columngroup>\n            </ng-template>\n          </ng-template>\n        </form>\n      </div>\n    </div>\n  </div>\n  <div class=\"remodal_btns\">\n    <ul class=\"remodal_btns_group\">\n      <li>\n        <button data-remodal-action=\"cancel\" type=\"reset\" class=\"remodal_btns_group-cancel\" (click)=\"onEvent($event, 'cancel', '')\">{{ (msg | async)['Button_cancel'] }}</button>\n      </li>\n      <li>\n        <button type=\"submit\" class=\"remodal_btns_group-ok\" (click)=\"onEvent($event, 'update', '')\">{{ (msg | async)['Button_update'] }}</button>\n      </li>\n    </ul>\n  </div>\n</div>\n<!-- /remodal -->\n"
                }] }
    ];
    /** @nocollapse */
    BulkComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: ListService },
        { type: ColumnService },
        { type: AlertModalService }
    ]; };
    BulkComponent.propDecorators = {
        remodalElement: [{ type: ViewChild, args: ['remodal',] }]
    };
    return BulkComponent;
}(EntryComponent));
export { BulkComponent };
//# sourceMappingURL=bulk.component.js.map